import axios from 'axios'
import { config } from '../config'
import { isClientError } from './apiError'
import { clearSession, getToken } from './session'

const baseURL = config.apiUrl

export const api = axios.create({
	baseURL: `${baseURL}/v1`,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
	},
	timeout: 15000,
})

// Request interceptor to add auth token
api.interceptors.request.use(config => {
	const token = getToken()
	if (token) {
		config.headers.set('Authorization', `Bearer ${token}`)
	}
	return config
})

api.interceptors.response.use(
	response => response,
	error => {
		// Handle 401 errors by clearing auth and redirecting to login
		if (error.response?.status === 401) {
			clearSession()
			window.location.href = '/'
		}
		const errorToReject = error instanceof Error ? error : new Error(String(error))
		return Promise.reject(errorToReject)
	},
)

/**
 * Unauthenticated instance for the public share pages: no auth header, no
 * credentials, no 401-redirect — a logged-in visitor sees what a logged-out one
 * sees, and an expired session never bounces a public page to login.
 */
export const publicApi = axios.create({
	baseURL: `${baseURL}/v1`,
	headers: {
		'Content-Type': 'application/json',
	},
	timeout: 15000,
})

/** Retry once for transient failures, never for deterministic 4xx. */
export const publicQueryRetry = (failureCount: number, error: unknown): boolean =>
	!isClientError(error) && failureCount < 1

export default api
